import { FC, PropsWithChildren, createContext, useContext } from "react";

interface SeoProviderProps {
  appName: string | undefined;
}

const SeoContext = createContext<string | undefined>(undefined);

const useSeoContext = () => {
  const context = useContext(SeoContext);

  if (!context)
    throw new Error("No SeoContext.Provider found when calling useSeoContext.");

  return context;
};

const SeoProvider: FC<PropsWithChildren<SeoProviderProps>> = ({
  appName,
  children,
}) => {
  return <SeoContext.Provider value={appName}>{children}</SeoContext.Provider>;
};

export { SeoProvider, useSeoContext };
